//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '../../shared-components/upload/UploadFile';
import basePath from '../../common/functions/api-resource';
import exportacao from '../../common/resources/downloads';
import { generateComputed } from '../../common/functions/roles-computed-generator';

export default {
  data() {
    return {
      execucaoResources: this.$api.execucao(this.$resource),
      arquivosSuportados: 'application/pdf',
      evidencias: [],
      execucaoSelecionada: null,
      drawer: false,
    };
  },
  props: {
    maxFileSizeInMB: {
      type: Number,
      default: 10,
    },
    idMeta: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: '',
    },
    referencia: {
      type: String,
      default: '',
    },
    deletar: {
      type: Boolean,
      default: false,
    },
    tela: {
      type: String,
      default: 'APURACAO',
    },
  },
  watch: {
    idMeta(value) {
      this.idMeta = value;
      this.listarEvidencias();
    },
    status(value) {
      this.status = value;
    },
    deletar(value) {
      this.deletar = value;
    },
    referencia(valor) {
      this.referencia = valor;
    },
  },
  computed: {
    importUrlExcucaoMetas() {
      const urlUpload = basePath('execucao', 'execucao');
      return `${urlUpload}/upload?id_meta`;
    },
    uploadFileMetaDropzoneId() {
      return `myVueDropzone${(Math.random() * Math.random() * 100).toString().replace('.', '')}`;
    },
    showImport() {
      return this.idMeta !== 0;
    },
    permiteUpload() {
      return ['AGUARDANDO_APURACAO', 'EM_CADASTRO', 'EM_ANALISE'].includes(this.status);
    },
    possuiEvidencias() {
      return this.evidencias && this.evidencias.length !== 0;
    },
    permiteDeletar() {
      return this.deletar !== false && this.canAccessUpload;
    },
    ...generateComputed('EXECUCAO', [
      'canEdit',
    ]),
    canAccessUpload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'APU_UPLOAD').length;
    },
    canAccessDownload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'APU_DOWNLOAD').length;
    },
  },
  components: {
    UploadFile,
  },
  methods: {
    close() {
      this.$emit('EXECUCAOSIDEBAR_CLOSE');
    },
    open(ref) {
 // eslint-disable-line
    },
    toggle() {
      this.drawer = !this.drawer;
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    openConfirmDialog(row) {
      this.execucaoSelecionada = row;
      this.$refs.confirmDialog.open();
    },
    listarEvidencias(callback) {
      if (this.idMeta === 0 || !this.canAccessDownload) {
        return;
      }
      const id = this.idMeta;
      this.execucaoResources.listar({ id }, { id })
      .then((response) => {
        this.evidencias = response.data;
        if (!this.evidencias.length && callback) {
          callback();
        }
      })
      .catch((err) => {
        this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    removerEvidencia() {
      const callback = () => this.$emit('ARQUIVO_REMOVIDO', this.referencia);
      if (this.execucaoSelecionada) {
        const idExecucao = this.execucaoSelecionada.id;
        this.execucaoResources.remover({ idExecucao }, { idExecucao })
        .then(() => {
          this.$toast.create(this.$t('message.execucao_removida') || msg, 'snack', 5E3);
          this.listarEvidencias(callback);
        })
        .catch((err) => {
          this.$toast.create(err.data.error, 'snack', 3E3);
        });
      }
    },
    uploadMetaSuccess(object, msg) {
      this.$toast.create(this.$t('message.execucao_metas') || msg, 'snack', 5E3);
      this.listarEvidencias();
      this.$emit('EXECUCAOSIDEBAR_REFRESH_APURACAO', this.referencia);
    },
    uploadError(file, msg) {
      const acepted = file.accepted;
      if (!acepted) {
        this.$refs.dropZoneReivindicacao.numMaxArquivos = true;
        this.$toast.create(this.$t(msg.erros[0]) || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
      }
      this.$toast.create(this.$t(msg.erros[0]) || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    visualizarArquivo(row) {
      const getBasePath = basePath('execucao', 'execucao');
      const resource = exportacao(this.$http);

      resource.downloadGetAba(getBasePath, {
        param: '',
        url: `${row.id}/pdf`,
      })
      .then(() => {
      })
      .catch(() => {
        this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/sidebar/ExecucaoSidebar.vue?vue&type=script&lang=js&